/** Shared Tailwind class strings for dashboard product managers */

export const inputClass =
  "mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500";

export const textareaClass =
  "mt-1 w-full min-h-[90px] rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500";

export const labelClass = "block text-sm font-medium text-slate-700";

export const sectionCardClass = "rounded-xl border border-slate-200 bg-slate-50/60 p-4";

export const sectionTitleClass = "text-sm font-semibold text-[#0b1f3f] mb-3";

export const btnSecondary =
  "inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl border border-slate-300 bg-white text-sm font-medium text-slate-700 hover:bg-slate-50 transition";

export const btnPrimary =
  "inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-xl bg-[#0b1f3f] text-white text-sm font-medium hover:bg-[#132d54] transition disabled:opacity-60";

export const btnAccent =
  "inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-xl bg-[#FE7E3F] text-white text-sm font-medium hover:bg-[#e86f32] transition disabled:opacity-60";

export const btnDanger =
  "inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl border border-rose-200 text-rose-700 text-sm font-medium hover:bg-rose-50 transition";

export const btnEdit =
  "inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl border border-[#0b1f3f]/25 text-[#0b1f3f] text-sm font-medium hover:bg-[#0b1f3f]/5 transition";

export const fileInputClass =
  "w-full text-sm file:mr-3 file:px-3 file:py-2 file:rounded-lg file:border-0 file:bg-slate-200 file:text-slate-700 hover:file:bg-slate-300";

export const langTabActive = "px-3 py-1.5 rounded-lg text-xs font-medium bg-[#0b1f3f] text-white border border-[#0b1f3f]";

export const langTabIdle =
  "px-3 py-1.5 rounded-lg text-xs font-medium border border-slate-300 text-slate-700 hover:bg-white bg-white";
